import { render, staticRenderFns } from "./NotificationsPreferences.vue?vue&type=template&id=7df24f96&scoped=true&"
import script from "./NotificationsPreferences.vue?vue&type=script&setup=true&lang=ts&"
export * from "./NotificationsPreferences.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./NotificationsPreferences.vue?vue&type=style&index=0&id=7df24f96&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df24f96",
  null
  
)

export default component.exports